"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var salesforceLanguages = [{
  title: 'Arabic',
  value: 'ar'
}, {
  title: 'Bulgarian',
  value: 'bg'
}, {
  title: 'Croatian',
  value: 'hr'
}, {
  title: 'Chinese (Simplified)',
  value: 'zh-CN'
}, {
  title: 'Chinese (Traditional)',
  value: 'zh-TW'
}, {
  title: 'Czech',
  value: 'cs'
}, {
  title: 'Danish',
  value: 'da'
}, {
  title: 'Dutch',
  value: 'nl-NL'
}, {
  title: 'English (UK)',
  value: 'en-GB'
}, {
  title: 'English',
  value: 'en-US'
}, {
  title: 'Finnish',
  value: 'fi'
}, {
  title: 'French',
  value: 'fr'
}, {
  title: 'German',
  value: 'de'
}, {
  title: 'Greek',
  value: 'el'
}, {
  title: 'Hebrew',
  value: 'iw'
}, {
  title: 'Hungarian',
  value: 'hu'
}, {
  title: 'Italian',
  value: 'it'
}, {
  title: 'Indonesian',
  value: 'in'
}, {
  title: 'Japanese',
  value: 'ja'
}, {
  title: 'Korean',
  value: 'ko'
}, {
  title: 'Norwegian',
  value: 'no'
}, {
  title: 'Polish',
  value: 'pl'
}, {
  title: 'Portuguese (European)',
  value: 'pt-PT'
}, {
  title: 'Portuguese (Brazil)',
  value: 'pt-BR'
}, {
  title: 'Romanian',
  value: 'ro'
}, {
  title: 'Russian',
  value: 'ru'
}, {
  title: 'Slovak',
  value: 'sk'
}, {
  title: 'Slovenian',
  value: 'sl'
}, {
  title: 'Spanish',
  value: 'es'
}, {
  title: 'Spanish (Mexico)',
  value: 'es-MX'
}, {
  title: 'Swedish',
  value: 'sv'
}, {
  title: 'Thai',
  value: 'th'
}, {
  title: 'Turkish',
  value: 'tr'
}, {
  title: 'Ukrainian',
  value: 'uk'
}, {
  title: 'Vietnamese',
  value: 'vi'
}];
var _default = salesforceLanguages;
exports.default = _default;